import GetHelpModal from 'Components/CommonComponents/Modal/HelpModal';
import UploadPrescriptionModal from 'Components/CommonComponents/Modal/UploadPrescriptionModal';
import GetACallBackModal from 'Pages/Home/Components/GetACallBackModal';

export const MenuList = [
  [
    { link: '/blood-tests', name: 'Book a Blood Tests', isloc: true },
    { link: '/health-packages', name: 'Book a Health Package', isloc: true },
    {
      link: '/unifit-weekend-wellness',
      name: 'Unifit Weekend Wellness',
      isloc: true
    },
    { link: '/testing-specialty', name: 'Testing Speciality' }
  ],
  [
    { link: '/my-reports', name: 'Download Report' },
    {
      link: '/about-us',
      id: 1,
      name: 'Upload Prescription',
      onclick: true
    },
    {
      link: '/privacy-policy',
      name: 'Get a Call Back',
      id: 2,
      onclick: true
    },
    {
      link: '/locatelab',
      name: 'Locate A Lab'
    }
  ],
  [
    { link: '/why-unipath', name: 'Why Unipath' },
    {
      link: '/privacy-policy',
      name: 'Help and Feedback',
      onclick: true,
      id: 3
    },
    // { link: '/career', name: 'Careers' },

    {
      link: '/offers',
      name: 'Offers'
    }
  ]
];
